import { useEffect, useRef, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";

export function OtpDialog({ token, action, onClose, onDone }) {
  const [code, setCode] = useState("");
  const [sent, setSent] = useState(null);
  const [busy, setBusy] = useState(false);
  const base = `/public/portal/${token}`;
  const send = async () => { try { const { data } = await api.post(`${base}/otp`); setSent(data.sent_to); } catch (e) { setSent(""); toast.error(errMsg(e)); } };
  const sentOnce = useRef(false);
  useEffect(() => { if (!sentOnce.current) { sentOnce.current = true; send(); } }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const confirm = async () => {
    setBusy(true);
    try {
      if (action.kind === "erase") { const { data } = await api.post(`${base}/erase`, { otp: code }); toast.success(data.status === "completed" ? "Your data has been erased." : "Processed. Records kept by the employer's HR system were not deleted."); }
      else { const { data } = await api.post(`${base}/withdraw`, { otp: code, purposes: action.purposes }); toast.success(`Consent withdrawn. ${data.results?.[0]?.jobs_cancelled || 0} pending task(s) stopped.`); }
      onDone();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="portal-otp-dialog">
        <DialogHeader>
          <DialogTitle>{action.kind === "erase" ? "Confirm erasure" : "Confirm consent withdrawal"}</DialogTitle>
          <DialogDescription>{sent ? `We emailed a 6-digit code to ${sent}.` : sent === "" ? "We couldn't send a code just now. Wait a few minutes, then use \"Send a new code\"." : "Sending a code to your email…"} {action.kind === "erase" && "Erasure can't be undone."}</DialogDescription>
        </DialogHeader>
        <Input inputMode="numeric" maxLength={6} value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))} placeholder="123456" aria-label="Verification code" data-testid="portal-otp-input" />
        <div className="flex justify-between gap-2">
          <Button variant="ghost" size="sm" onClick={send} data-testid="portal-otp-resend">Send a new code</Button>
          <Button size="sm" disabled={code.length !== 6 || busy} onClick={confirm} className={action.kind === "erase" ? "bg-risk hover:bg-risk/90" : ""} data-testid="portal-otp-confirm">{busy && <Loader2 size={14} className="animate-spin" />}Confirm</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
